function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "20",
  height: "20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M14.167 5h1.666c.92 0 1.667.746 1.667 1.667v9.166c0 .92-.746 1.667-1.667 1.667H4.167c-.92 0-1.667-.746-1.667-1.667V6.667C2.5 5.747 3.246 5 4.167 5h1.666M17.5 14.167h-15",
  stroke: "currentColor",
  strokeWidth: "1.278",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M5.833 7.5V2.776c0-.315.178-.603.46-.744l.549-.276a.833.833 0 01.743-.003l1.03.51h-.004l1.02-.508a.833.833 0 01.746.001l1.008.506 1.03-.509a.833.833 0 01.744.002l.549.276c.281.142.459.43.459.745V7.5H5.833z",
  stroke: "currentColor",
  strokeWidth: "1.278",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.333 10.833H6.667",
  stroke: "currentColor",
  strokeWidth: "1.278",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));